import TextWithLineBreaks from 'components/TextWithLineBreaks'
import React from 'react'

import styled from 'styled-components'

const ReviewContentWrapper = styled.div`
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  overflow: hidden;
`

const AnimatedText = styled.span<{ hide?: boolean }>`
  opacity: ${({ hide }) => (hide ? 0 : 1)};
  display: ${({ hide }) => (hide ? 'block' : 'inline')};
  height: ${({ hide }) => (hide ? 0 : 'auto')};
  transition: opacity 0.8s ease-in-out;
`

const ReviewContent = ({
  content,
  showMore,
  truncateLength,
}: {
  content: string
  showMore: boolean
  truncateLength: number
}) => {
  const realTruncate = truncateLength - 100 // Makes sure that the truncate doesn't just show a couple of words
  return (
    <div style={{ marginBottom: '24px' }}>
      {content.length > truncateLength ? (
        <>
          <ReviewContentWrapper>
            <TextWithLineBreaks text={content.substring(0, realTruncate)} />
            {!showMore && '...'}
            <AnimatedText hide={!showMore}>
              <TextWithLineBreaks
                text={content.substring(realTruncate, content.length)}
              />
            </AnimatedText>
          </ReviewContentWrapper>
        </>
      ) : (
        <ReviewContentWrapper>{content}</ReviewContentWrapper>
      )}
    </div>
  )
}

export default ReviewContent
